const constants = require("../Domain/constants");
const Api = require("./ApiPrimary");
const ApiSls = require("./ApiSls");
const ApiLocal = require("./ApiLocal");
const ApiProject = require("./ApiProject");

const isAwsUser = constants.userType !== "mono";
const fetchCacheProduct = false;

const ApiBasedOnUserType = {
  getMyProfile: async (options = {}) => {
    let _isAwsUser = isAwsUser;
    if (options.tokenType) {
      _isAwsUser = options.tokenType !== "mono";
    }
    return _isAwsUser ? await ApiSls.getMyProfile() : await Api.getMyProfile();
  },
  editMyProfile: async (data, options = {}) => {
    let _isAwsUser = isAwsUser;
    if (options.tokenType) {
      _isAwsUser = options.tokenType !== "mono";
    }
    return _isAwsUser
      ? await ApiSls.editMyProfile(data)
      : await Api.editMyProfile(data);
  },
  fetchProductById: async id => {
    return fetchCacheProduct
      ? await ApiLocal.fetchProductById(id)
      : await Api.fetchProductById(id);
  },
  fetchProductByIds: async ids => {
    return fetchCacheProduct
      ? await ApiLocal.fetchProductByIds(ids)
      : await Api.fetchProductByIds(ids);
  },
  fetchProducts: async ({
    limit,
    sort,
    offset,
    search,
    label,
    store,
    is_on_shelf
  }) => {
    return fetchCacheProduct
      ? await ApiLocal.fetchProducts({
          limit,
          sort,
          offset,
          search,
          label,
          store,
          is_on_shelf
        })
      : await Api.fetchProducts({
          limit,
          sort,
          offset,
          search,
          label,
          store,
          is_on_shelf
        });
  },
  fetchProductsByStoreId: async id => {
    return fetchCacheProduct
      ? await ApiLocal.fetchProductsByStoreId(id)
      : await Api.fetchProductsByStoreId(id);
  },
  createOrder: async data => {
    return isAwsUser
      ? await ApiSls.createOrder(data)
      : await Api.createOrder(data);
  },
  getOrderList: async () => {
    return isAwsUser ? await ApiSls.getOrderList() : await Api.getOrderList();
  },
  getOrder: async id => {
    return isAwsUser ? await ApiSls.getOrder(id) : await Api.getOrder(id);
  },
  updateStoreOrder: async (id, data) => {
    return isAwsUser
      ? await ApiSls.updateStoreOrder(id, data)
      : await Api.updateStoreOrder(id, data);
  },

  getStoreOrderByOrderId: async id => {
    return ApiSls.getStoreOrderByOrderId(id);
  },

  // admin
  listStoreOrder: async ({ store, tokenType, from, to }) => {
    return isAwsUser
      ? await ApiSls.listStoreOrder({ store, tokenType, from, to })
      : await Api.listStoreOrder({ from, to });
  },

  adminListOrder: async ({ from, to }) => {
    let resp = await ApiSls.adminListOrder({ from, to });
    return resp;
  },

  getStaffProfile: async () => {
    return await Api.getMyProfile();
  }
};

module.exports = {
  ...Api,
  ...ApiBasedOnUserType,
  sls: ApiSls,
  local: ApiLocal,
  ...ApiProject
};
